import WorkScheduleProto from "../work-schedule/work-schedule-proto";
import {momentRange} from "../../convert/moment-range";

export function calculateWorkdayDuration(startMoment:Moment|null, endMoment:Moment|null, userId?:ID|null) : number | null {

    if (!startMoment || !endMoment) return null

    const workSchedule : WorkScheduleProto = userId ? gd.workSchedule.getUserWorkSchedule(userId) : gd.workSchedule.getCompanyWorkSchedule()

    const workdays: number = workSchedule.calculateWorkdays(momentRange(startMoment, endMoment))

    if (workdays !== 0) return workdays

    return null

}